// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__3S9ZQ","showModal":"Modal_showModal__3xv3d","outer":"Modal_outer__3p4Uo","close":"Modal_close__3qPlc","gallery":"Modal_gallery__10umA"};